import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export enum BankProviders {
  WAAS = "WAAS",
  REMOTE_WALLET = "REMOTE_WALLET",
}

interface BankProviderConfigState {
  availableProviders: ProviderOption[];
}

const initialState: BankProviderConfigState = {
  availableProviders: [],
};

const bankProviderConfigSlice = createSlice({
  name: "bankProviderSlice",
  initialState,
  reducers: {
    setAvailableProviders: (state, action: PayloadAction<ProviderOption[]>) => {
      state.availableProviders = action.payload;
    },
  },
});

export const bankProviderConfigActions = bankProviderConfigSlice.actions;
export default bankProviderConfigSlice.reducer;
